import { getChoicesFromBFF } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/getChoicesFromBFF";

export type ChoiceData = {
  /** The ID of the choice. */
  id: string;
  /** The choice value. */
  choice: string;
};

/** Helper function to get the choices */
export const getChoicesData = async () => {
  const sectorChoices: ChoiceData[] = await getChoicesFromBFF("65379");
  const seniorityChoices: ChoiceData[] = await getChoicesFromBFF("65381");

  return { sectorChoices, seniorityChoices };
};
